import styled from 'styled-components'
import { Link, Grid, Icon } from 'components/atoms'

export const Root = styled.div`
  margin-top: 30px;
  padding: 20px 30px 30px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.13);
  background-color: #f8f8f8;
  margin-bottom: 20px;
  position: relative;

  h2 {
    margin-bottom: 0;
  }
`

export const Service = styled.div`
  height: 100%;
  padding: 10px 23px 19px;
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
  background-color: #ffffff;
`

export const ServiceIcon = styled(Icon)`
  color: ${ (props) => props.theme.colors.weiss };
  width: 45px;
  height: 45px;
  background: ${ (props) => props.theme.colors.hellgruen1 };
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  position: absolute;
  right: 0;
  top: 0;
`

export const ServiceHeader = styled(Grid)`
  margin-bottom: 30px;

  & > div:first-child {
    padding-left: 0;
  }

  .mandant {
    color: ${ (props) => props.theme.colors['aok-gruen'] };
  }
`

export const ServiceContent = styled(Grid)`
  & > div {
    width: 100%;
    padding: 5px 15px;
  }
`

export const ServiceType = styled.div`
  width: 100%;
`

export const ServiceLink = styled(Link)`
  font-size: 22px;
`
